<template>
  <div class="device-tab-page">
    <management-table
      title="控制器电池数据"
      embedded
      :data="tableData"
      :loading="loading"
      :current-page="query.pageNum"
      :page-size="query.pageSize"
      :total="total"
      empty-text="暂无电池数据"
      @current-change="onPageChange"
    >
      <template slot="filters">
        <div class="search-item">
          <label class="search-label">电站名称:</label>
          <el-select v-model="query.stationId" class="search-select" clearable filterable
            :filter-method="filterStation" @visible-change="onStationDropdownVisible"
            placeholder="请选择或输入电站名称">
            <el-option v-for="item in stationList" :key="item.id"
              :label="item.stationName" :value="item.id" />
          </el-select>
        </div>
        <div class="search-item">
          <label class="search-label">控制器选择:</label>
          <el-select v-model="query.id" class="search-select" clearable filterable placeholder="请选择控制器">
            <el-option
              v-for="item in deviceList"
              :key="item.id"
              :label="item.deviceName"
              :value="item.id"
            />
          </el-select>
        </div>
      </template>

      <template slot="actions">
        <el-button type="primary" icon="el-icon-search" class="search-btn" @click="serch">搜索</el-button>
      </template>

      <template slot="columns">
          <el-table-column type="index" fixed="left" width="50" label="序号" align="center" />
          <el-table-column
            v-for="column in tableColumns"
            :key="column.prop"
            :label="column.label"
            :prop="column.prop"
            :width="column.width"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row[column.prop] != null">{{ scope.row[column.prop] }}{{ column.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="数据时间"
            prop="uploadTime"
            fixed="right"
            width="170"
            align="center"
            show-overflow-tooltip
          />
      </template>
    </management-table>
  </div>
</template>

<script>
import ManagementTable from '../../components/ManagementTable.vue';

const BATTERY_VOLTAGE_COLUMNS = Array.from({ length: 15 }, (_, index) => ({
  label: `电池电压${index + 1}`,
  prop: `dcdy${index + 1}`,
  width: 110,
  unit: 'V'
}));

const BATTERY_TEMPERATURE_COLUMNS = Array.from({ length: 4 }, (_, index) => ({
  label: `电池温度${index + 1}`,
  prop: `dcwd${index + 1}`,
  width: 110,
  unit: '℃'
}));

export default {
  name: 'DeviceOneDianChiVue',
  components: {
    ManagementTable
  },
  props: {
    id: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 9,
        deviceType: 1,
        id: null,
        stationId: null
      },
      deviceList: [],
      allStationList: [],
      stationList: [],
      tableColumns: [
        { label: '设备名称', prop: 'deviceName', width: 130, unit: '' },
        { label: '状态', prop: 'zt', width: 100, unit: '' },
        { label: '警告', prop: 'jg', width: 100, unit: '' },
        { label: '保护', prop: 'bh', width: 100, unit: '' },
        { label: '故障', prop: 'gz', width: 120, unit: '' },
        { label: '电流', prop: 'dl', width: 120, unit: 'A' },
        { label: '电压', prop: 'dy', width: 120, unit: 'V' },
        { label: '电量', prop: 'dianliang', width: 120, unit: 'Ah' },
        { label: '电池健康', prop: 'dianchijk', width: 120, unit: '' },
        { label: '剩余电池容量', prop: 'sydcrl', width: 140, unit: '' },
        { label: '满电容量', prop: 'mdrl', width: 120, unit: '' },
        { label: '设计容量', prop: 'sjrl', width: 120, unit: '' },
        { label: '电池循环次数', prop: 'dcxhcs', width: 140, unit: '次' },
        { label: '均衡状态', prop: 'jhzt', width: 110, unit: '' },
        ...BATTERY_VOLTAGE_COLUMNS,
        ...BATTERY_TEMPERATURE_COLUMNS
      ]
    };
  },
  mounted() {
    if (this.id != null) this.query.id = this.id;
    this.loadStationList();
    this.loadAllList();
    this.loadPage();
  },
  methods: {
    onPageChange(val) {
      this.query.pageNum = val;
      this.loadPage();
    },
    serch() {
      this.query.pageNum = 1;
      this.loadPage();
    },
    loadPage() {
      this.loading = true;
      this.$request.post('/api/device/gf/dc/page', this.query).then(response => {
        if (response.data.result) {
          this.tableData = response.data.data.list;
          this.total = response.data.data.totalCount;
        } else {
          this.$Message.error('获取电池数据失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取电池数据失败！');
      }).finally(() => {
        this.loading = false;
      });
    },
    loadStationList() {
      this.$request.get('/api/power/station/options').then(response => {
        if (response.data.result) {
          this.allStationList = response.data.data || [];
          this.stationList = this.allStationList.slice();
        } else {
          this.$Message.error('获取电站列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取电站列表失败！');
      });
    },
    filterStation(query) {
      const keyword = String(query || '').trim().toLocaleLowerCase();
      this.stationList = keyword ? this.allStationList.filter(item =>
        String(item.stationName || '').toLocaleLowerCase().includes(keyword)
      ) : this.allStationList.slice();
    },
    onStationDropdownVisible(visible) {
      if (visible) this.stationList = this.allStationList.slice();
    },
    loadAllList() {
      const queryForm = { pageNum: 1, pageSize: 10000 };
      this.$request.post('/api/device/page', queryForm).then(response => {
        if (response.data.result) {
          this.deviceList = response.data.data.list;
        } else {
          this.$Message.error('获取设备列表失败,请联系管理员!');
        }
      }).catch(() => {
        this.$Message.error('网络异常，获取设备列表失败！');
      });
    }
  }
};
</script>

<style src="./deviceOneTabShared.css" scoped></style>
